module.exports = __webpack_public_path__ + "img/ch07_11_公交车窗.674c63b3.jpg";